import { render, staticRenderFns } from "./disciplinary.vue?vue&type=template&id=4ed9136c"
import script from "./disciplinary.vue?vue&type=script&lang=js"
export * from "./disciplinary.vue?vue&type=script&lang=js"
import style0 from "./disciplinary.vue?vue&type=style&index=0&id=4ed9136c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports